{
  "name": "hexasync-cli-nodejs",
  "description": "HexaSync CLI",
  "version": "2608.21.2",
  "type": "module",
  "bin": {
    "hexasync": "./dist/main.js"
  },
  "main": "./dist/main.js",
  "engines": {
    "node": ">=22.13"
  },
  "scripts": {
    "build": "rm -rf dist && node ./scripts/esbuild.js",
    "build-and-install": "rm -rf dist && node ./scripts/esbuild.js && npm i -g",
    "cli": "node --loader=ts-node/esm ./src/main.ts",
    "lint:ts": "tsc --noEmit",
    "typecheck": "tsc --noEmit",
    "prepack": "cp ../../README.md ./README.md",
    "postpack": "rm -f ./README.md"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.30.0",
    "axios": "^1.9.0",
    "chalk": "^5.4.1",
    "commander": "^11.1.0",
    "conf": "^12.0.0",
    "curlconverter": "^4.12.0",
    "deepmerge": "^4.3.1",
    "esbuild": "^0.25.5",
    "fast-glob": "^3.3.3",
    "fuse.js": "^7.1.0",
    "glob": "^11.0.2",
    "graphql": "^16.11.0",
    "inquirer": "^9.3.7",
    "js-yaml": "^4.1.0",
    "jsonata": "^2.0.6",
    "lodash-es": "^4.17.21",
    "parse-json": "^8.3.0",
    "plural": "^1.1.0",
    "pluralize": "^8.0.0",
    "reflect-metadata": "^0.1.14",
    "tsyringe": "^4.10.0",
    "uuid": "^14.0.2",
    "xpath": "^0.0.34",
    "yaml": "^2.8.0",
    "yaml-loader": "^0.8.1",
    "zod": "^3.25.0"
  },
  "devDependencies": {
    "@beehexa/hexasync-template-assets": "2608.21.4",
    "@beehexa/hexasync-template-compose": "2608.21.4",
    "@beehexa/hexasync-template-engine": "2608.21.4",
    "@beehexa/hexasync-template-frontend-flow": "2608.21.4",
    "@beehexa/hexasync-template-index": "2608.21.4",
    "@beehexa/hexasync-template-io-node": "2608.21.4",
    "@beehexa/hexasync-template-model": "2608.21.4",
    "@beehexa/hexasync-template-ports": "2608.21.4",
    "@beehexa/hexasync-template-report-model": "2608.21.4",
    "@beehexa/hexasync-template-report-render": "2608.21.4",
    "@beehexa/hexasync-template-validate": "2608.21.4",
    "@beehexa/hexasync-template-worker-flow": "2608.21.4",
    "@tsconfig/node18": "^18.2.4",
    "@types/inquirer": "^9.0.8",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^20.19.0",
    "@types/yaml": "^1.9.6",
    "esbuild-node-externals": "^1.18.0",
    "esbuild-plugin-copy": "^2.1.1",
    "nodemon": "^3.1.10",
    "prettier": "^3.5.3",
    "prettier-plugin-packagejson": "^2.5.15",
    "raw-loader": "^4.0.2",
    "ts-node": "^10.9.2",
    "tsconfig-paths": "^4.2.0",
    "tslib": "^2.8.1",
    "typescript": "^5.8.3",
    "typescript-plugin-yaml": "^0.0.5",
    "vitest": "^4.1.10",
    "yaml-loader": "^0.8.1"
  }
}
